import ajax from "../../lib/appfuse-react/core/ajax";

const frequentlyAskedQuestionService = {
    findAll: async () => {
        const response = await ajax.get("frequentlyAskedQuestions");
        return response.data;
    }
}

export default frequentlyAskedQuestionService;